/**
 * Coups de pouce — Attendu 646 « Calculer l'aire d'un carré ou d'un
 * rectangle ».
 *
 * Une entrée par `generator_key` (cf. gen_646.js) : les 5 formats partagent la
 * même confusion-cible (aire vs périmètre) — une seule fiche pour les 2 clés.
 * Les formules ne fuient rien : les phrases à trous du gen les affichent déjà
 * en clair, le travail résiduel est le calcul. Exemple HORS pools : côté 20
 * (les côtés du gen vont de 2 à 15). Figure : le MÊME rectangle deux fois —
 * tour orange épais (périmètre) vs intérieur rempli (aire).
 */

// Couleurs EXPLICITES (jamais de currentColor — thème sombre élève).
const SVG_AIRE_PERIMETRE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 130" width="300" height="115" role="img"
     aria-label="Le même rectangle deux fois : le périmètre est son tour, l'aire est la surface intérieure">
  <rect x="20" y="20" width="120" height="70" fill="none" stroke="#fb923c" stroke-width="5"/>
  <rect x="200" y="20" width="120" height="70" fill="#bfdbfe" stroke="#64748b" stroke-width="1.5"/>
  <text x="80" y="112" text-anchor="middle" font-size="13" font-weight="bold" fill="#0f172a">le périmètre : le tour</text>
  <text x="260" y="112" text-anchor="middle" font-size="13" font-weight="bold" fill="#0f172a">l'aire : l'intérieur</text>
</svg>`.trim();

const FICHE_AIRE = {
    pages: [
        {
            titre: 'Aire ou périmètre ?',
            lignes: [
                'Le **périmètre** est la longueur du **tour** (en cm). L\'**aire** est la surface **à l\'intérieur** (en cm²).',
                'Aire du rectangle : **L × l**. Aire du carré : **c × c**. Le périmètre, lui, **additionne les côtés**.',
            ],
            svg: SVG_AIRE_PERIMETRE,
        },
        {
            titre: 'Un exemple',
            lignes: [
                'Carré de côté **20** cm : Aire = 20 × 20 = **400 cm²**.',
                'Périmètre = 4 × 20 = **80 cm**. Deux questions différentes, deux résultats différents.',
            ],
        },
    ],
};

const CP_646 = {
    calcul_aire_figure: FICHE_AIRE,
    calcul_aire_figure_qcm_unique: FICHE_AIRE,
    calcul_aire_figure_texte: FICHE_AIRE,
    aire_perimetre: FICHE_AIRE,
    aire_perimetre_qcm_unique: FICHE_AIRE,
    aire_perimetre_texte_trou_saisie: FICHE_AIRE,
    aire_perimetre_relier: FICHE_AIRE,
};

export default CP_646;
